import React, {memo} from "react";
import TitlesModals from "../../TitlesModals";
import {useSelector} from "react-redux";

import LoaderModals from "../../../loaders/LoaderModals";
import CardItemModalBasketCartProduct from "../../../card/CardItemModalBasketCartProduct";
import {FaShoppingBasket} from "react-icons/all";
import _ from "lodash";

const ListProductsBody = () => {
    const {loaderListProducts} = useSelector(state => state.modalShoppingCard);
    const {carts, apiCarts} = useSelector(state => state.shoppingCart);


    const renderListProduct = () => {
        const listProduct = [];
        if (apiCarts && apiCarts.basket)
            if (_.size(carts) === _.size(apiCarts.basket))
                for (const CART in carts) {
                    for (const API_CARD in apiCarts.basket) {
                        if (carts[CART].grades[0].gradeId === API_CARD) {
                            listProduct.push({
                                gradeId: carts[CART].grades[0].gradeId,
                                image: carts[CART].images[0],
                                gradeTitle: carts[CART].grades[0].gradeTitle,
                                name: carts[CART].name,
                                unit: carts[CART].grades[0].unit,
                                w_numbers: carts[CART].w_numbers,
                                price: parseFloat(apiCarts.basket[API_CARD].price) * parseFloat(carts[CART].w_numbers),
                                status: apiCarts.basket[API_CARD].status,
                                productId: carts[CART].productId,
                                optionSelect: carts[CART].optionSelect,
                                forFoodPack: (carts[CART].grades[0].forFoodPack !== undefined ? carts[CART].grades[0].forFoodPack : false),
                            })
                        }
                    }
                }

        return listProduct.map(product => {
            return product.status ? (
                <CardItemModalBasketCartProduct key={product.gradeId} data={{product}} showEdit={true}/>) : null;
        });

    };

    return !loaderListProducts ? (
        <React.Fragment>
            {/*<BoxClickChangeAddress data={{destination:'MODAL_LIST_PRODUCTS_BODY'}}/>*/}
            <div className={'box-list-items-shopping-card'}>
                <TitlesModals>
                    <span>کالاهای انتخابی شما</span>
                </TitlesModals>
                {carts.length > 0 ?
                    <div className={'child-list-items-shopping-card'}>
                        {renderListProduct()}
                    </div>
                    :
                    <div className={'empty-shopping-card-logo'}>
                        <div>
                            <div className={'cm-box-empty-icon-shopping-card'}><FaShoppingBasket
                                className={'cm-empty-icon-shopping-card'}/></div>
                            <div><span>سبد خرید شما خالی است</span></div>
                        </div>
                    </div>
                }
            </div>
        </React.Fragment>
    ) : <LoaderModals/>;
};

export default memo(ListProductsBody);
